import { createContext, useContext, useState } from 'react'

// Types de formulaires disponibles
export const FORM_TYPES = {
  EDIT: 'edit',           // Formulaire d'édition d'un mandat existant
  CLOSE: 'close'          // Formulaire de clôture d'un mandat
}

// Création du contexte avec des valeurs par défaut
export const MandatFormContext = createContext({
  // Type de formulaire actif
  formType: FORM_TYPES.EDIT,
  setFormType: () => {},
  
  // Fonctions de gestion des erreurs
  getErrorMessage: () => '',
  hasError: () => false,
  
  // Données du formulaire
  control: null,
  mandat: null,
  isLoading: false,
  
  // Fonctions de callback pour la modale
  onClose: () => {},
  onSuccess: () => {},
})

// Provider du contexte
export const MandatFormProvider = ({ children, initialFormType = FORM_TYPES.EDIT, ...contextValues }) => {
  const [formType, setFormType] = useState(initialFormType)
  
  return (
    <MandatFormContext.Provider
      value={{
        ...contextValues,
        formType,
        setFormType
      }}
    >
      {children}
    </MandatFormContext.Provider>
  )
}

// Hook personnalisé pour utiliser le contexte
export const useMandatForm = () => {
  const context = useContext(MandatFormContext)
  
  if (!context) {
    throw new Error('useMandatForm doit être utilisé à l\'intérieur d\'un MandatFormProvider')
  }
  
  return context
}